import React from "react";
import { Box } from "@material-ui/core";
import useStyles from "./styles";
import AnswerCard from "./AnswerCard";

export default function AnswerField({ item, emptyLabel = "", showCorrectAnswer = false, presentation, number }) {
  const classes = useStyles();
  const input = String(item.userInput ?? "");
  const graded = Object.prototype.hasOwnProperty.call(item, "rightAnswerWasInInput");
  const className = item.excludedFromScoring || !graded ? classes.userInput
    : item.rightAnswerWasInInput ? classes.userInputCorrect : classes.userInputIncorrect;
  if (presentation === "card") return <AnswerCard item={item} number={number} />;
  return <>
    <Box className={classes.Title}>{item.title}</Box>
    {/^https?:\/\//i.test(input) ? <a href={input} target="_blank" rel="noopener noreferrer" className={classes.userInputLink}>{input}</a> :
      <Box className={className}>
        {input.trim() ? input : emptyLabel}
        {item.excludedFromScoring ? <Box mt={1}>حذف از آزمون</Box> : item.scoringPolicy === "creditAll" ?
          <Box mt={1}>پاسخ صحیح برای همه</Box> : <>
            {item.rightAnswer && (showCorrectAnswer || (graded && !item.rightAnswerWasInInput)) &&
              <Box mt={1}>پاسخ صحیح: {item.rightAnswer}</Box>}
            {showCorrectAnswer && !item.rightAnswer && <Box mt={1}>پاسخ صحیح تعریف نشده است</Box>}
          </>}
      </Box>}
  </>;
}
